import * as React from "react";
import logo from "@/resources/logo.png"
import placeholder from "@/resources/placeholder.png"
import {postElement} from "@/lib/api/apiUtils";
import ReactMarkdown from "react-markdown";
import AnimatedLoader from "@/resources/animated-loader";


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
export default function Feelsy() {
    return (

        <div className="bg-[#000b55] h-screen sm:overflow-hidden">
            <div className="relative isolate ">
                <div
                    aria-hidden="true"
                    className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                >
                    <div
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                    />
                </div>
                <div className="py-10 ">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-20">
                        <div className="mx-auto max-w-2xl text-center">
                            <img src={logo} alt={'logo'} className={"w-[300px] items-center mx-auto flex"} />
                            <h1 className="text-balance text-4xl font-semibold tracking-tight text-white sm:text-4xl">
                                How can assist you today?
                            </h1>
                        </div>
                        <div className="mt-8 flow-root sm:mt-24">
                            <Chat />
                        </div>
                    </div>
                </div>
                <div
                    aria-hidden="true"
                    className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                >
                    <div
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                        className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                    />
                </div>
            </div>
        </div>


    )
}


const Chat = () => {


    const [chatId, setChatId] = React.useState(false);
    const [isLoadingPost, setLoadingPost] = React.useState(false);
    const [messages, setMessages] = React.useState([]);
    const [newMessage, setNewMessage] = React.useState("");
    const chatList = React.useRef();

    const handleSend = (e) => {
        e.preventDefault();
        if (!newMessage.trim()) return;
        setLoadingPost(true);

        setMessages((prev) => [
            ...prev,
            {
                id: Date.now(),
                sender: "me",
                name: "Me",
                avatar: placeholder,
                text: newMessage,
                date: new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                }),
            },
        ]);
        setNewMessage("");
        setTimeout(() => {
            chatList.current.scrollIntoView({ behavior: "smooth" })
        }, 200);
        let messageData = {question: newMessage};
        if(chatId){
            messageData['chatId'] =  chatId;
        }


        postElement('/chat/ask', messageData).then(async response => {
            setMessages((prev) => [
                ...prev,
                {
                    id: Date.now(),
                    sender: "other",
                    name: "Feelsy",
                    avatar: logo,
                    text: response.answer,
                    date: new Date().toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    }),
                },
            ]);
            setChatId(response.chatId);
            setLoadingPost(false);
            setTimeout(() => {
                chatList.current.scrollIntoView({ behavior: "smooth" })
            }, 200);
        }).catch(async (e) => {
            setLoadingPost(false);
        });
    }

    return (
        <div className="flex flex-col h-[400px] bg-gray-900 rounded-lg sm:overflow-hidden">
            {/* Chat messages */}
            <ul className="flex-1 overflow-y-auto space-y-4 p-4" >
                {messages.map((msg) => (
                    <li
                        key={msg.id}
                        className={classNames("flex items-end", msg.sender === "me" && "justify-end")}
                    >
                        {msg.sender === "other" && (
                            <img
                                src={msg.avatar}
                                alt={msg.name}
                                className="w-11 h-8 rounded-full mr-2"
                            />
                        )}

                        <div
                            className={classNames(
                                "max-w-xs rounded-lg px-3 py-2 text-sm",
                                msg.sender === "me"
                                    ? "bg-indigo-600 text-white"
                                    : "bg-white/10 text-gray-200"
                            )}
                        >

                            {msg.sender === "other" ? (
                                <ReactMarkdown
                                    components={{
                                        p: ({ children }) => <p style={{ marginBottom: "8px" }}>{children}</p>
                                    }}
                                >
                                    {msg.text}
                                </ReactMarkdown>
                            ) : (
                                <p>{msg.text}</p>
                            )}





                            <span className="block mt-1 text-[10px] text-gray-400">
                                {msg.date}
                            </span>
                        </div>

                        {msg.sender === "me" && (
                            <img
                                src={msg.avatar}
                                alt={msg.name}
                                className="w-8 h-8 rounded-full ml-2"
                            />
                        )}
                    </li>
                ))}



                {
                    isLoadingPost && (
                        <>
                            <li
                                className={classNames("flex items-end")}
                            >
                                <img
                                    src={logo}
                                    alt={'feelsy'}
                                    className="w-11 h-8 rounded-full mr-2"
                                />
                                <div
                                    className={classNames(
                                        "max-w-xs rounded-lg px-3 py-2 text-sm", "bg-white/10 text-gray-200 "
                                    )}
                                >
                                    <p> <AnimatedLoader className="  w-5 h-5"/></p>
                                    <span className="block mt-1 text-[10px] text-gray-400">
                                         {new Date().toLocaleTimeString([], {
                                             hour: "2-digit",
                                             minute: "2-digit",
                                         })}
                                    </span>
                                </div>
                            </li>


                        </>
                    )
                }

            <li ref={chatList}></li>
            </ul>

            {/* Input */}
            <form
                onSubmit={handleSend}
                className="flex items-center p-3 bg-gray-800"
            >
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className="p-2 text-gray-400 hover:text-white cursor-pointer"*/}
                {/*>*/}
                {/*    <AudioWaveformIcon className="w-5 h-5"/>*/}
                {/*</button>*/}
                <input
                    type="text"
                    placeholder="Scrivi un messaggio..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    className="flex-1 bg-transparent outline-none px-3 py-2 text-white placeholder-gray-400"
                />
                <button
                    type="submit"
                    className="px-3 py-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-500"
                >
                    Send
                </button>
            </form>
        </div>
    );
};
